import { axiosHrClient } from '../plugins/axios'

const leave = {
  namespaced: true,

  actions: {
    getSystemMenusAdmin() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            '/hrportal/self/catelogroles/0/programitemroles'
          )
          let list_obj = {}
          res.data.data.forEach(item => {
            if (!Array.isArray(list_obj[item.programCatelogFullNameTha]))
              list_obj[item.programCatelogFullNameTha] = []
            list_obj[item.programCatelogFullNameTha].push({
              name: item.programItemFullNameTha,
              programItemMenuID: item.programItemMenuID,
              itemPath: item.programItemPath,
              otherSystem: item.otherSystem
            })
          })
          const list = []
          for (let key in list_obj) {
            list.push({
              title: key,
              menus: list_obj[key]
            })
          }
          resolve(list)
        } catch (e) {
          reject(e)
        }
      })
    },
    // getSystemMenus() {
    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const res = await axiosHrClient.get(
    //         `/hrportal/self/catelogroles/0/programitemroles`
    //       )
    //       console.log('tete' + JSON.stringify(res))
    //       const list = res.data.data.map(item => {
    //         const obj = {}
    //         obj.title = item.menuInSystemFullNameTha
    //         obj.menus = item.data.map(subItem => {
    //           return {
    //             name: subItem.menuInSystemFullNameTha,
    //             programItemMenuID: subItem.programItemMenuID,
    //             itemPath: subItem.menuInSystemPath,
    //             otherSystem: subItem.otherSystem
    //           }
    //         })
    //         return obj
    //       })
    //       resolve(list)
    //     } catch (e) {
    //       reject(e)
    //     }
    //   })
    // },
    // getInfo() {
    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const res = await axiosReqCardClient.get(
    //         `/employees/self/requestinfoByEmId`
    //       )
    //       resolve(res)
    //     } catch (e) {
    //       reject(e)
    //     }
    //   })
    // },

    adminmanageAccessroles(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/adminmanage/accessroles/`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    adminmanageAccessrolList(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/adminmanage/accessroles/` + payload + `/employees`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    adminmanageAccessrolDel(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.delete(
            `/adminmanage/accessroles/` +
              payload.accessRoleID +
              `/employees/` +
              payload.employeeID +
              `/organizations/` +
              payload.roleOrganizationID
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    programcatelogsList() {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(`/adminmanage/programcatelogs`)
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    getInAccessRoleList(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/adminmanage/accessroles/` +
              payload.accessRoleId +
              `/programcatelogs/` +
              payload.programCatelogId +
              `/menus`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    payLoadInAccessApi(ctx, payload) {
      // console.log('qwe ' + JSON.stringify(payload))
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/adminmanage/accessroles/menus`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    organList(ctx, payload) {
      // console.log('qwe ' + JSON.stringify(payload))
      if (payload.organId === '') {
        payload.organId = 1
      }
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/hrreference/organizations/` +
              payload.orgTypeFlag +
              `/` +
              payload.organId
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    dataTab1Api(ctx, payload) {
      // console.log('qwe ' + JSON.stringify(payload))
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.get(
            `/adminmanage/accessroles/organizations/` +
              payload.organId +
              `/employees`
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    delTab1ConApi(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.delete(
            `/adminmanage/accessroles/` +
              payload.accessRoleID +
              `/employees/` +
              payload.employeeID
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    btnSearchTab2Api(ctx, payload) {
      // console.log('qwe ' + JSON.stringify(payload))
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/adminmanage/accessroles/keyword/employees`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    btnSearchTab3Api(ctx, payload) {
      // console.log('qwe ' + JSON.stringify(payload))
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/adminmanage/accessroles/programcatelogname/employees`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    employeessearchApi(ctx, payload) {
      // console.log('qwe ' + JSON.stringify(payload))
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/adminmanage/employeessearch`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },
    emSaveApi(ctx, payload) {
      // console.log('qwe ' + JSON.stringify(payload))
      return new Promise(async (resolve, reject) => {
        try {
          const res = await axiosHrClient.post(
            `/adminmanage/accessroles/addemployeerole`,
            payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default leave
